import { MaintenancePart } from "../models/checkup";
import ApiService from "../services/api";

export const fetchParts = async (searchTerm?: string): Promise<MaintenancePart[]> => {
  const apiService = new ApiService(import.meta.env.VITE_MARKETPLACE_API_URL);

  try {
    const response = await apiService.get<{ content: any[] }>(`payment-gateway/backoffice/products`, { params: { page: 0, size: 20, searchTerm, type: "PART", isActive: true } });
    if (response.status === 200) {
      return (response.data?.content ?? [])
        .filter((part: any) => part.code)
        .map((part: any) => ({
          code: part.code,
          model: part.sku,
          description: part.name,
        }));
    } else {
      return [];
    }
  } catch (error: any) {
    console.error(error);
    return [];
  }
}